module.exports = __webpack_public_path__ + "static/media/nfe_logo_transp.cc4fdb35.png";